import { render, staticRenderFns } from "./SignupEdit.vue?vue&type=template&id=c038ea5e&"
import script from "./SignupEdit.vue?vue&type=script&lang=ts&"
export * from "./SignupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports